import React from 'react';
import styled from 'styled-components';

import { Medium, SemiBold, Bold } from './Text';
import Counter from './Counter';

import { FONT } from '../../styles/color';
import { SHIPPING_FEE } from '../../utils/constants';

const Container = styled.div`
    width: 100%;
    min-width: 480px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    box-sizing: border-box;

    container-type: inline-size;
`;

const LineWrapper = styled.div`
    width: 100%;
    height: 240px;
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    border-bottom: 2px solid ${ FONT.mid };

    @container (max-width: 750px) {
        flex-wrap: wrap;
        height: auto;
        min-height: 240px;
        margin-top: 20px;
    }
`;

const CheckboxWrapper = styled.div`
    width: 50px;
    height: 100%;
    display: ${ props => props.$isVisible ? 'flex' : 'none' };
    align-items: center;
    justify-content: center;

    @container (max-width: 750px) {
        width: 100%;
        height: 40px;
        justify-content: flex-start;
        margin-top: -20px;
    }
`;

const ItemWrapper = styled.div`
    height: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: flex-start;
    align-items: center;

    @container (max-width: 750px) {
        width: 100%;
        flex-shrink: 0;
        flex-basis: 100%;
        height: auto;
        min-height: 180px;
        margin-bottom: 20px;
    }
`;

const ItemImage = styled.img`
    width: 180px;
    height: 180px;
    border-radius: 4px;
`;

const ItemInfo = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 27px;
`;

const PriceWrpper = styled.div`
    display: flex;
    width: 160px;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: center;

    @container (max-width: 750px) {
        width: 50%;
        height: auto;
        min-height: 180px;
        box-sizing: border-box;
        border-left: none !important;
        border-top: solid 1px ${ FONT.mid } !important;
    }
`;

const EmptyCart = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid ${ FONT.mid };
`;

function CartItem(props) {
    const [count, setCount] = React.useState(props.item.quantity || 1);

    const onCountUp = () => {
        const newCount = count + 1;
        setCount(newCount);
        props.onQuantityChange && props.onQuantityChange(props.index, newCount);
    }

    const onCountDown = () => {
        const newCount = count - 1;
        setCount(newCount);
        props.onQuantityChange && props.onQuantityChange(props.index, newCount);
    }

    const setCountAs = (value) => {
        setCount(value);
        props.onQuantityChange && props.onQuantityChange(props.index, value);
    }

    const handleCheckboxChange = (e) => {
        props.onToggleSelect && props.onToggleSelect(props.index, e.target.checked);
    }

    return (
        <LineWrapper>
            <CheckboxWrapper $isVisible={ props.$useCheckbox }>
                <input type="checkbox" checked={ props.isSelected } onChange={ handleCheckboxChange } />
            </CheckboxWrapper>
            <ItemWrapper>
                <ItemImage src={ props.item.productThumbnail }/>
                <ItemInfo>
                    <div>
                        <SemiBold size="24px" useEllipsis={ true }>{ props.item.productName }</SemiBold>
                    </div>
                    <SemiBold size="16px" useEllipsis={ true }>
                        { props.item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원
                    </SemiBold>
                    <Counter count={ count } onCountUp={ onCountUp } onCountDown={ onCountDown } setCountAs={ setCountAs }
                        style={{ border: `solid 1px ${ FONT.default }` }}
                        isActive={ props.$useCheckbox }
                    />
                </ItemInfo>
            </ItemWrapper>
            <PriceWrpper style={{ borderLeft: `solid 1px ${ FONT.mid }`, borderRight: `solid 1px ${ FONT.mid }` }}>
                <Medium size="16px" color={ FONT.deep01 }>상품금액</Medium>
                <SemiBold size="20px">{(props.item.price * count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원</SemiBold>
            </PriceWrpper>
            <PriceWrpper>
                <Medium size="16px" color={ FONT.deep01 }>배송비</Medium>
                <SemiBold size="20px">{(SHIPPING_FEE * count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원</SemiBold>
            </PriceWrpper>
        </LineWrapper>
    );
}

export default function CartList(props) {
    if(props.items.length === 0) {
        return (
            <EmptyCart>
                <Medium size="16px" color={ FONT.deep01 }>장바구니에 담긴 상품이 없습니다.</Medium>
            </EmptyCart>
        );
    }

    return (
        <Container>{
            props.items.map((item, index) => (
                <CartItem
                    $useCheckbox={ props.$useCheckbox }
                    index={index}
                    item={item}
                    isSelected={props.selectedItems[index] || false}
                    onToggleSelect={props.onToggleSelect}
                    onQuantityChange={props.onQuantityChange}
                />
            ))}
        </Container>
    );
}